import angular from 'angular';

angular.module('ll')
  .component('energywidget', {
    controller: function () {},
    template: require('./energywidget.html')
  });
